import type { UserT } from '@/stores/user.store'

declare global {
  interface Window {
    clarity?: (command: string, ...args: unknown[]) => void
  }
}

const clarityCall = (command: string, ...args: unknown[]) => {
  if (typeof window === 'undefined' || !window.clarity) return
  window.clarity(command, ...args)
}

export const clarityIdentify = (userId: string, friendlyName?: string) => {
  clarityCall('identify', userId, undefined, undefined, friendlyName)
}

export const claritySet = (key: string, value: string) => {
  clarityCall('set', key, value)
}

const mapBookStage = (status: UserT['bookStatus']): string => {
  if (!status) return 'not_started'
  if (status === 'in_progress') return 'in_progress'
  if (status === 'submitted_to_print') return 'ready_to_print'
  if (status === 'shipped') return 'printed'
  return 'not_started'
}

export const setClarityUserContext = (user: UserT) => {
  const clientCode = user.externalInfo?.code

  const userId = clientCode ?? user.id
  if (!userId) return

  clarityIdentify(userId, user.email || userId)
  if (user.email) claritySet('email', user.email)
  if (clientCode) claritySet('client_code', clientCode)
  claritySet('locale', user.locale ?? 'unknown')
  claritySet('book_stage', mapBookStage(user.bookStatus))
}

export const clearClarityUser = () => {
  claritySet('client_code', 'logged-out')
  claritySet('email', 'logged-out')
}
